import { DtacBase } from "./dtac-base";
import { Value, VALUE_TEMPLATE } from "./value";


export interface VolumetricWeight extends DtacBase {
  chargeableWeight: Value;
}

export const VOLUMETRIC_WEIGHT_TEMPLATE: VolumetricWeight = {
  '@id': '',
  '@type': '',
  chargeableWeight: VALUE_TEMPLATE
};
